var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgGreenBorderCircle = props => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "117 0 17 17",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  "data-name": "Path 280377"
}, /*#__PURE__*/React.createElement("path", {
  d: "M131.5 8.5a6 6 0 1 1-12 0 6 6 0 0 1 12 0Z",
  fill: "#fff",
  fillRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  d: "M131.5 8.5a6 6 0 1 1-12 0 6 6 0 0 1 12 0Z",
  strokeLinejoin: "round",
  strokeLinecap: "round",
  strokeWidth: 2.1176399999999997,
  stroke: "#26890d",
  fill: "transparent"
}))));
export default SvgGreenBorderCircle;